import React from "react"
import { Link } from "gatsby"

import { ResizedImage as Image } from "@components/shared"
import { withHtml } from "@components/logic"

import { paragraphGray, descriptionNavy } from "@styles/typography.module.scss"
import { button__tertiary } from "@styles/button.module.scss"
import { IPostElement } from "../types"

import {
  postItem,
  postItem__header,
  postItem__header__content,
  postItem__img,
  postItem__excerpt,
} from "../styles/post.module.scss"

const formatDate = (value: Date) => {
  const formated = new Date(value)
  return `${formated.getUTCDate()}.${formated.getUTCMonth()}.${formated.getUTCFullYear()}`
}

const Title = withHtml("h3")
const subtitle =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"

const PostPreview: React.FC<IPostElement> = ({
  title,
  slug,
  date,
  featuredImage,
  tags,
}): JSX.Element => (
  <article className={postItem}>
    <div className={postItem__header}>
      <Link to={`/blog/${slug}/`}>
        <Title className={descriptionNavy}>{title}</Title>
      </Link>
      <div className={postItem__header__content}>
        <p className={paragraphGray}>Dodano {formatDate(date)}</p>
        <ul>
          {tags.nodes.map(({ name, id, slug: tagSlug }) => (
            <li key={id}>
              <Link
                to={`/tags/${tagSlug}/`}
                className={paragraphGray}
              >{`#${name}`}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <Link to={`/blog/${slug}/`} className={postItem__img}>
      <Image size="600w" {...featuredImage} />
    </Link>

    <div className={postItem__excerpt}>
      <p className={paragraphGray}>{subtitle}</p>
      <Link to={`/blog/${slug}/`} className={button__tertiary}>
        Czytaj więcej
      </Link>
    </div>
  </article>
)

export default PostPreview
